
const wishlistname='wishlist';

export var wishlist = getWishList();

export function addToWishlistClick(id){
    wishlist = JSON.parse(localStorage.getItem(wishlistname));
    if(!(wishlist)) wishlist=[];
    const index = wishlist.findIndex(x=>x.id == id);
    if(index !== -1)
        wishlist.splice(index,1);
    else{
        wishlist.push({"id":id});
    }
    localStorage.setItem(wishlistname, JSON.stringify(wishlist));
    return wishlist;
}

export function getWishList(){
    var wishlistl = JSON.parse(localStorage.getItem(wishlistname));
    if(!(wishlistl)) wishlistl=[];
    return wishlistl;
}

export function isInWishlist(id){
    const index = wishlist.findIndex(x=>x.id == id);
    if(index !== -1)
        return true;
    else
        return false;
}